import React, { useMemo } from 'react';
import useStats from '../hooks/useStats';
import StatsTable from './common/StatsTable';
import TIME_PERIODS from './constants/periods';

const RESOURCE = '/v1/statistics/voice_recordings';
const INITIAL_STATE = {};

const RecordingStats = () => {
  const { data: recordingStats, loading } = useStats({
    resource:     RESOURCE,
    initialState: INITIAL_STATE,
  });

  const columns = useMemo(() => [
    { header: 'Call recording minutes', id: 'recording' },
    { header: 'Inbound', id: 'inbound', className: 'text-center' },
    { header: 'Outbound', id: 'outbound', className: 'text-center' },
  ], []);

  const rows = useMemo(() => [
    {
      period: TIME_PERIODS.TODAY,
      values: [
        { id: 'inbound-rec-today', value: recordingStats.inboundRecordingsToday },
        { id: 'outbound-rec-today', value: recordingStats.outboundRecordingsToday },
      ],
    },
    {
      period: TIME_PERIODS.THIS_WEEK,
      values: [
        { id: 'inbound-rec-week', value: recordingStats.inboundRecordingsThisWeek },
        { id: 'outbound-rec-week', value: recordingStats.outboundRecordingsThisWeek },
      ],
    },
    {
      period: TIME_PERIODS.THIS_MONTH,
      values: [
        { id: 'inbound-rec-month', value: recordingStats.inboundRecordingsThisMonth },
        { id: 'outbound-rec-month', value: recordingStats.outboundRecordingsThisMonth },
      ],
    },
    {
      period: TIME_PERIODS.LAST_MONTH,
      values: [
        { id: 'inbound-rec-last-month', value: recordingStats.inboundRecordingsLastMonth },
        { id: 'outbound-rec-last-month', value: recordingStats.outboundRecordingsLastMonth },
      ],
    },
  ], [recordingStats]);

  return (
    <StatsTable
      title="Call recording minutes"
      columns={columns}
      rows={rows}
      loading={loading}
    />
  );
};

export default React.memo(RecordingStats);
